import { ChildModel } from "@/services";
import { GetterTree } from "vuex";
import { ParentState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<ParentState, any> = {
  //children
  [defineVuexName(MODULES.PARENT.GETTERS.GET_CHILDREN)](state: ParentState): Array<ChildModel> {
    return state.children;
  },
  //acceptPolicy
  [defineVuexName(MODULES.PARENT.GETTERS.GET_ACCEPT_POLICY)](state: ParentState): boolean {
    return state.acceptPolicy;
  },
};

export default getters;
